var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoGameAgreement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.79 22.605a.947.947 0 1 0 0 1.895h9.473a.947.947 0 1 0 0-1.895zm0 3.79a.947.947 0 1 0 0 1.895h9.473a.947.947 0 1 0 0-1.895zm-.948 4.737c0-.523.424-.948.948-.948h9.473a.947.947 0 1 1 0 1.895H18.79a.947.947 0 0 1-.948-.947"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.053 14c0-.523.424-.947.947-.947h12.401c.251 0 .492.1.67.277l4.775 4.775a.95.95 0 0 1 .277.67V35a.947.947 0 0 1-.947.947H15a.947.947 0 0 1-.947-.947zm1.894.947h9.556v4.778c0 .523.424.948.948.948h4.777v13.38h-15.28V14.947Zm14.892 3.83-3.441-3.44v3.44z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGameAgreement);
export default __webpack_public_path__ + "static/media/IcoGameAgreement.3d2c6d570a4d52c9ee63105981acbcc0.svg";
export { ForwardRef as ReactComponent };